var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34797 18.6671C7.97464 18.6671 7.65686 18.5359 7.39464 18.2737C7.13241 18.0115 7.0013 17.694 7.0013 17.3212V7.00039H6.16797V6.16706H9.5013V5.52539H14.5013V6.16706H17.8346V7.00039H17.0013V17.3212C17.0013 17.7046 16.873 18.0248 16.6163 18.2821C16.3596 18.5393 16.0391 18.6676 15.6546 18.6671H8.34797ZM16.168 7.00039H7.83464V17.3212C7.83464 17.4707 7.88269 17.5934 7.9788 17.6896C8.07491 17.7857 8.19797 17.8337 8.34797 17.8337H15.6555C15.7832 17.8337 15.9007 17.7804 16.008 17.6737C16.1152 17.5671 16.1685 17.4493 16.168 17.3204V7.00039ZM10.1746 16.1671H11.008V8.66706H10.1746V16.1671ZM12.9946 16.1671H13.828V8.66706H12.9946V16.1671Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.dae866386654395e2fb0e5d89e7f1275.svg";
export { ForwardRef as ReactComponent };